// Turns a raw product description (may contain HTML tags, \r\n line breaks,
// ";"-separated bullet fragments) into a clean, single-line meta description
// truncated to Google's effective snippet length (~155-160 chars).
export const getMetaDescription = (raw: string, maxLength = 155): string => {
  const clean = raw
    .replace(/<[^>]*>/g, ' ')
    .replace(/[\r\n;]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (clean.length <= maxLength) return clean;

  const truncated = clean.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return `${truncated.slice(0, lastSpace > 0 ? lastSpace : maxLength)}…`;
};
